import React, { useRef, useState } from "react"
import { SwiperSlide, Swiper } from "swiper/react"
import { Navigation, Pagination } from "swiper/modules"

import * as S from "./testimonials.styles"

// Import Swiper styles
import "swiper/css"
import "swiper/css/navigation"
import "swiper/css/pagination"
import "swiper/css/autoplay"
import { useMediaQuery, useTheme } from "@mui/material"
import CustomArrows from "../../components/custom-arrows/custom-arrows.component"
import { positions } from "@mui/system"

const Testimonials = props => {
  const { title, testimonials } = props
  const [progressIndex, setProgressIndex] = useState(0)
  const sliderRef = useRef(null)
  const theme = useTheme()
  const isDesktop = useMediaQuery(theme.breakpoints.up("md"))
  return (
    <S.Section>
      <S.Wrapper>
        <S.Title>{title}</S.Title>
        <Swiper
          modules={[Navigation, Pagination]}
          autoHeight={!isDesktop}
          // pagination={true}
          loop={true}
          breakpoints={{
            300: {
              spaceBetween: 30,
              slidesPerView: 1,
            },
            600: {
              spaceBetween: 30,
              slidesPerView: 1,
            },
            800: {
              spaceBetween: 50,
              slidesPerView: 1.7,
            },
            1200: {
              spaceBetween: 20,
              slidesPerView: 2.5,
            },
          }}
          navigation={{
            prevEl: ".prevInfoSlider",
            nextEl: ".nextInfoSlider",
          }}
          onSlideChange={() =>
            setProgressIndex(sliderRef?.current?.swiper?.realIndex)
          }
          ref={sliderRef}
        >
          {testimonials?.map(({ logo, description, title }, index) => (
            <SwiperSlide key={`${title}-${index}`}>
              <S.ContentContainer>
                <S.TopContainer>
                  <S.LogoContainer>
                    <S.Logo img={logo} />
                  </S.LogoContainer>
                  <S.CardTitle>{title}</S.CardTitle>
                </S.TopContainer>
                <S.Description>{description}</S.Description>
              </S.ContentContainer>
            </SwiperSlide>
          ))}
        </Swiper>
        <CustomArrows
          leftArrow="prevInfoSlider"
          rightArrow="nextInfoSlider"
          number={progressIndex}
          length={testimonials.length}
          className="dark"
        />
      </S.Wrapper>
    </S.Section>
  )
}

export default Testimonials
